import React from 'react'
import { LinearProgress, LinearProgressProps } from '@mui/material'

export default function CustomLinearProgress(
    props: LinearProgressProps & {
        backgroundcolor: string
        barbackgroundcolor: string
    },
) {
    const { backgroundcolor, barbackgroundcolor, sx, ...rest } = props

    return (
        <LinearProgress
            sx={[
                {
                    backgroundColor: backgroundcolor,
                    borderRadius: 999,
                    // background (не backgroundColor) — принимает и градиент, и цвет
                    '.MuiLinearProgress-bar': {
                        background: barbackgroundcolor,
                        borderRadius: 999,
                    },
                },
                // sx вызывающего мержим, а не перезатираем нашими цветами
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...rest}
        />
    )
}
